import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {DateTime} from "luxon";
import {formatFromISOToDate, subtractYears} from "../../../utils/dateTimeHelper";

export const useIdentityForm = (data) => {
    const {t} = useTranslation();

    const defaultValues = useMemo(() => ({
        forename: data?.forename || "",
        preferredName: data?.preferredName || "",
        surname: data?.surname || "",
        suffix: data?.suffix || "",
        dateOfBirth: data?.dateOfBirth ? formatFromISOToDate(data?.dateOfBirth) : "",
        genderTypeId: data?.genderTypeId || "",
    }), [data]);

    const schema = useMemo(() => yup.object().shape({
        forename: yup.string().required(t("validation.required")),
        preferredName: yup.string(),
        surname: yup.string().required(t("validation.required")),
        suffix: yup.string(),
        dateOfBirth: yup.string().required(t("validation.required"))
            .test("min-age", t("validation.dateOfBirth.tooYoung"), (value) => {
                if (!value) return true;
                return DateTime.fromISO(value) <= DateTime.fromJSDate(subtractYears(7));
            })
            .test("max-age", t("validation.dateOfBirth.tooOld"), (value) => {
                if (!value) return true;
                return DateTime.fromISO(value) >= DateTime.fromJSDate(subtractYears(25));
            }),
        genderTypeId: yup.string().required(t("validation.required")),
    }), [t]);

    const {
        control,
        handleSubmit,
        formState: {errors, isValid, isDirty},
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues,
    });

    return {
        handleSubmit,
        control,
        errors,
        isValid,
        isDirty,
    };
};
